import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, PopoverContent, PopoverHeading } from "@similarweb/ui-components";

export const SettingPopoverContentStyled = styled(PopoverContent)`
    position: relative;
    margin-left: 17px;
    border-radius: 6px;
    z-index: 1056;
    max-width: 229px;
    padding: 0;
    box-shadow: 0 18px 34px 0 rgba(14, 30, 62, 0.2);
`;

export const SettingPopoverHeadingStyled = styled(PopoverHeading)`
    position: absolute;
    right: 5px;
    top: 5px;
    justify-content: flex-end;
`;

export const SettingPopoverDescriptionStyled = styled(FlexColumn)`
    align-items: center;
    padding: 16px 8px;
`;

export const SettingPopoverTitleWrapper = styled.div`
    padding: 0 13px 16px 13px;
    text-align: center;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const SettingPopoverImageStyled = styled.img`
    width: 110px;
    height: 110px;
`;
